document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('#notification-block-form');
  const popup = document.querySelector('.section-notification-popup');
  const popupWrap = popup.querySelector('.notification-block');
  const closeButton = document.querySelector('.notification-close-popup');
  const maxShowTimes = parseInt(popupWrap.getAttribute('data-show-notifications'), 10);
  let closeCount = sessionStorage.getItem('popupCloseCount') || 0;
  let formSubmitted = localStorage.getItem('newsletterFormSubmitted') || false;
  let popupShown = false;

  function showPopup() {
    if (!popupShown && closeCount < maxShowTimes && !formSubmitted) {
      popup.classList.remove('popup-hidden');
      popupShown = true;
    }
  }

  function hidePopup() {
    popup.classList.add('popup-hidden');
    closeCount++;
    sessionStorage.setItem('popupCloseCount', closeCount);
  }

  function checkScroll() {
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const scrolledPercentage = (scrollPosition / pageHeight) * 100;

    if (scrolledPercentage > 30) {
      setTimeout(showPopup, 5000);
      window.removeEventListener('scroll', checkScroll);
    }
  }

  if (closeCount < maxShowTimes) {
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const initialScrolledPercentage = (scrollPosition / pageHeight) * 100;

    if (initialScrolledPercentage > 30) {
      setTimeout(showPopup, 5000);
    } else {
      window.addEventListener('scroll', checkScroll);
    }
  }

  closeButton.addEventListener('click', hidePopup);
  closeButton.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      hidePopup();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      hidePopup();
    }
  });

  form.addEventListener('submit', (event) => {
    localStorage.setItem('newsletterFormSubmitted', 'true');
  })

});